import { Domain } from '@repo/domain';
export class ParkAppTypesenseRepository {
    config;
    constructor(config) {
        this.config = config;
    }
    capabilities = {
        [Domain.PartialParking]: async () => {
            return (ParkAppTypesenseRepository.partialParkingRepoPromise ??=
                import('./repositories/PartialParkingRepository').then((module) => {
                    return new module.PartialParkingRepository(this.config);
                }));
        },
    };
    static partialParkingRepoPromise;
}
